import React from "react";
import NavBar from "../../../components/admin/careerCounciling/psychometric/NavBar";
import { Outlet } from "react-router-dom";
import "../../../components/admin/careerCounciling/psychometric/psychometric.css";

function PsychoHome() {
  return (
    <div style={{ backgroundColor: "#0f0c29", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <NavBar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Outlet />
      </div>
    </div>
  );
}

export default PsychoHome;
